import { useMemo, useState } from "react";
import { currencyFormatter } from "../../../../utils/formatter/formatter";
import { StatusFilterSelect } from "./components/StatusFilterSelect";
import { OpportunityTable } from "./components/OpportunityTable";
import { OPPORTUNITY_SUMMARY, OPPORTUNITY_STATUS_OPTIONS, OPPORTUNITIES } from "./oportunidadesSortimento.data";

const DARK_GREEN = "#15803d";

// ícone de tendência — mesmo do banner de Qualificação de MIX
const TrendingUpIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 7h6v6" /><path d="m22 7-8.5 8.5-5-5L2 17" />
  </svg>
);

// numerozinho colorido do banner — alinhado à esquerda
const MiniStat = ({ value, label, color = "#1a1a1a" }) => (
  <div style={{ background: "#fff", border: "1px solid #e5e5e5", borderRadius: "10px", padding: "10px 18px", minWidth: 100 }}>
    <p style={{ fontSize: "20px", fontWeight: "800", color, margin: 0, textAlign: "left" }}>{value}</p>
    <p style={{ fontSize: "10.5px", color: "#888", marginTop: 2, whiteSpace: "nowrap", textAlign: "left" }}>{label}</p>
  </div>
);

// ícone "i" com tooltip no hover — fica fixo no canto superior direito do banner
const InfoTooltip = ({ text }) => {
  const [show, setShow] = useState(false);
  return (
    <div
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      style={{ position: "absolute", top: 10, right: 14 }}
    >
      <span style={{ width: 32, height: 32, borderRadius: "50%", background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center", cursor: "help" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      </span>
      {show && (
        <div style={{ position: "absolute", top: "calc(100% + 8px)", right: 0, width: 260, background: "#fff", border: "1px solid #16a34a", borderRadius: "8px", padding: "10px 12px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)", fontSize: "11.5px", color: "#555", lineHeight: 1.5, zIndex: 20 }}>
          {text}
        </div>
      )}
    </div>
  );
};

// Tela "Oportunidades de Sortimento"
export const OportunidadesSortimentoTab = () => {
  const [statusFilter, setStatusFilter] = useState("all");

  const filteredOpportunities = useMemo(
    () => (statusFilter === "all" ? OPPORTUNITIES : OPPORTUNITIES.filter((o) => o.type === statusFilter)),
    [statusFilter]
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1, minHeight: 0 }}>

      {/* card verde: ganho total esperado + mini stats + tooltip */}
      <section style={{
        position: "relative",
        background: "linear-gradient(90deg, #eafbf1 0%, #f3fdf6 100%)",
        border: "1px solid #cdeedb", borderRadius: "14px", padding: "18px 56px 18px 24px",
        display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0, gap: 16,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <span style={{ width: 44, height: 44, borderRadius: "50%", backgroundColor: "#16a34a", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <TrendingUpIcon />
          </span>
          <div>
            <p style={{ fontSize: "11px", fontWeight: "700", color: "#2ea043", letterSpacing: "0.06em" }}>GANHO TOTAL ESPERADO</p>
            <p style={{ fontSize: "26px", fontWeight: "800", color: DARK_GREEN, margin: "2px 0" }}>
              {currencyFormatter.format(OPPORTUNITY_SUMMARY.totalExpectedGain)}
            </p>
            <p style={{ fontSize: "12px", color: "#5a8a6b" }}>Projeção ao recuperar os Novos SKUs</p>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <MiniStat value={OPPORTUNITY_SUMMARY.productsAnalyzed} label="produtos analisados" />
          <MiniStat value={OPPORTUNITY_SUMMARY.newSkuCount} label="Novos SKUs" color="#E8773A" />
          <MiniStat value={OPPORTUNITY_SUMMARY.mixQualificationCount} label="qualificação de mix" color="#2563eb" />
          <MiniStat value={OPPORTUNITY_SUMMARY.toVerifyCount} label="a verificar" />
        </div>

        <InfoTooltip text="Dados YTD até 6/fev26. Gap = (Rank CS) − (Rank POA). Quanto maior, mais o produto é relevante em POA e invisível na CS." />
      </section>

      {/* filtro + contador — agora dentro de um card */}
        <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        border: "1px solid #ddd", borderRadius: "8px", padding: "12px 16px", background: "#fff",
        }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            <span style={{ fontSize: "13px", fontWeight: "700", color: "#555" }}>Filtrar por status</span>
            <StatusFilterSelect options={OPPORTUNITY_STATUS_OPTIONS} value={statusFilter} onChange={setStatusFilter} />
        </div>
        <span style={{ fontSize: "12.5px", color: "#999" }}>
            Mostrando {filteredOpportunities.length} de {OPPORTUNITIES.length} oportunidades
        </span>
        </div>

      {/* tabela — ordenação + expand/detalhe */}
      <OpportunityTable opportunities={filteredOpportunities} />
    </div>
  );
};
